import React, { Component } from 'react';
import 'bootstrap/dist/css/bootstrap.css'
import "./css/style.css"
import "./css/responsive.css"
import "./css/myyshopp.css"
import "./css/myyshopp-responsive.css"
import $ from "jquery";
import logo from "./images/logo.png";
import { Link } from 'react-router-dom';
import logo_orange from "./images/myyshopp-logo-orange.png";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBars, faTimes } from '@fortawesome/free-solid-svg-icons'

export default class header extends Component {
    mshoppmenuClick() {
        $(".myyshoppWrapper").addClass("myyshopp-main-wrapper-hidden")
        $(".myyshoppWrapperInner").addClass("myyshopp-main-wrapper-hidden")
        
    }
    mshoppmenuCLoseClick() {
        $(".myyshoppWrapper").removeClass("myyshopp-main-wrapper-hidden")
        $(".myyshoppWrapperInner").removeClass("myyshopp-main-wrapper-hidden")
    }
    render() {
        return (
            <div class="headermain">
                <div class="container">
                    <div class="logoDiv">
                        <a href="/">
                            <img src={logo} class="logo-img mshp-showwhtlogo" alt=""></img>
                            <img src={logo_orange} class="logo-img mshp-showclrlogo" alt=""></img>
                        </a>
                    </div>
                    <div class="mshopp-menuicon" onClick={this.mshoppmenuClick}>
                        <FontAwesomeIcon icon={faBars} size="lg"/>
                    </div>
                    {/* <div class="right-menu">
                        <div class="menu-item">Log In</div>
                        <div class="menu-item menu-item-btn"><button class="btn-theme">Start Now</button></div>
                    </div> */}
                    <div class="menuDiv">
                        <div class="mshopp-menu-close" onClick={this.mshoppmenuCLoseClick}>
                            <FontAwesomeIcon icon={faTimes} size="lg"/>
                        </div>
                        <div class="menu-item"><Link to="/myyshopp/mystory">Myystory</Link></div>
                        <div class="menu-item"><a href="/myyshopp/advantages">Advantages</a></div>
                        <div class="menu-item"><a href="/myyshopp/features">Features</a></div>
                        <div class="menu-item"><a href="/myyshopp/Pricing">Pricing</a></div>
                        {/* <div class="menu-item">Faq</div> */}
                        <div class="menu-item"><a href="/myyshopp/contact">Contact Us</a></div>
                        {/* <div class="right-menu">
                            <div class="menu-item">Log In</div>
                            <div class="menu-item menu-item-btn"><a href="/myyshopp/start-registration"><button class="btn-theme">Start Now</button></a></div>
                        </div> */}
                    </div>
                </div>
            </div>
        )
    }        
}